import { createAction } from '@ngrx/store';

export const clearStore = createAction('[App] Clear Store');